module.exports = __webpack_public_path__ + "img/comm-server.86f7f3c0.svg";